var ModalToggle = /** @class */ (function () {
    function ModalToggle() {
        this.body = document.querySelector('body');
        this.modalToggles = document.querySelectorAll('[data-toggle="modal"]');
        this.modalCloseToggles = document.querySelectorAll('[data-close-modal]');
        if (this.modalToggles.length > 0 && this.modalCloseToggles.length > 0) {
            this.addEventListeners();
        }
    }
    ModalToggle.prototype.addEventListeners = function () {
        var _this = this;
        this.modalToggles.forEach(function (toggle) {
            toggle.addEventListener('click', _this.toggleModal.bind(_this));
        });
        this.modalCloseToggles.forEach(function (toggle) {
            toggle.addEventListener('click', _this.toggleModal.bind(_this));
        });
    };
    ModalToggle.prototype.toggleModal = function (toggle) {
        toggle.preventDefault();
        var targetModal = toggle.currentTarget.dataset.target;
        var modal = document.querySelector("[data-modal=\"".concat(targetModal, "\"]"));
        if (!modal) {
            // If no modal found - do nothing
            return;
        }
        this.body.classList.toggle('no-scroll');
        modal.classList.toggle('active');
    };
    return ModalToggle;
}());
export default ModalToggle;
